module.exports = __webpack_public_path__ + "2f28aba7060bd08930f4dd3228d2b415.jpg";